import React from 'react';
import "./Packaging.css";
import images from '../../Asset/Img/img';
import "./Packaging.css"
import ModalApp from '../../Components/Modal/Modal';
import { useTranslation } from 'react-i18next';

function Packaging() {
  const { t } = useTranslation();
  return (
    <div className='packaging-container'>
      <div className='packaging-content'>
        <div className='packaging-header'>

          <div className='packaging-header-text'>
            <h4>{t('nav_packaging')}</h4>
          </div>
        </div>

        <div className='packaging-middle'>
          <h2>{t('packaging-header-text-mid')}</h2>



          <div className='packaging-box-container'>

            <div className='box-item box-item-one'>
              <div className='box-item-img-container'>
                <img src={images.packetOne} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>{t("packaging-box-item-one-p-one")}</strong>
                <p>{t("packaging-box-item-one-p-two")}</p>
                <strong>{t("packaging-box-item-one-p-three")}</strong>
                <li>{t("packaging-box-item-one-p-four")}</li>
                <li>{t("packaging-box-item-one-p-five")}</li>
              </div>
            </div>

            <div className='box-item box-item-two'>
              <div className='box-item-img-container'>
                <img src={images.packetTwo} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>{t('packaging-box-item-two-p-one')}</strong>
                <p>{t('packaging-box-item-two-p-two')}</p>
                <strong>{t('packaging-box-item-two-p-three')}</strong>
                <li>{t('packaging-box-item-two-p-four')}</li>
                <li>{t('packaging-box-item-two-p-five')}</li>
                <li>{t('packaging-box-item-two-p-six')}</li>
              </div>
            </div>

            <div className='box-item box-item-three'>
              <div className='box-item-img-container'>
                <img src={images.packetThree} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>{t('packaging-box-item-three-p-one')}</strong>
                <p>{t('packaging-box-item-three-p-two')}</p>
                <strong>{t('packaging-box-item-three-p-three')}</strong>
                <li>{t('packaging-box-item-three-p-four')}</li>
                <li>{t('packaging-box-item-three-p-five')}</li>
              </div>
            </div>

            <div className='box-item box-item-four'>
              <div className='box-item-img-container'>
                <img src={images.packetFour} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>{t('packaging-box-item-four-p-one')}</strong>
                <p>{t('packaging-box-item-four-p-two')}</p>
                <strong>{t('packaging-box-item-four-p-three')}</strong>
                <li>{t('packaging-box-item-four-p-four')}</li>
                <li>{t('packaging-box-item-four-p-five')}</li>
              </div>
            </div>

            <div className='box-item box-item-five'>
              <div className='box-item-img-container'>
                <img src={images.packetFive} alt="packet-icon" />
              </div>
              <div className='box-item-content'>
                <strong>{t('packaging-box-item-five-p-one')}</strong>
                <p>{t('packaging-box-item-five-p-two')}</p>
                <strong>{t('packaging-box-item-five-p-three')}</strong>
                <li>{t('packaging-box-item-five-p-four')}</li>
                <li>{t('packaging-box-item-five-p-five')}</li>
              </div>
            </div>

          </div>
        </div>

        <ModalApp />

      </div>
    </div>
  )
}

export default Packaging